import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { BecomeAFranchisee } from "./BecomeAFranchisee";
import { LargeOrders } from "./LargeOrders";
import { RecruitmentAds } from "./RecruitmentAds";
import { FormEmails } from "./FormEmails";

interface TabConfig {
    titleKey: string;
    component?: React.ComponentType;
}

const TAB_CONFIG: TabConfig[] = [
    { titleKey: "Become a Franchisee", component: BecomeAFranchisee },
    { titleKey: "Large Orders", component: LargeOrders },
    { titleKey: "Recruitment Ads", component: RecruitmentAds },
    { titleKey: "Emails", component: FormEmails },
];

export function Forms() {
    const { t } = useTranslation();
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const [activeTab, setActiveTab] = React.useState<number>(0);

    const toggleNav = useCallback(
        (tab: number) => {
            if (activeTab !== tab) setActiveTab(tab);
        },
        [activeTab]
    );

    return (
        <div data-testid="forms-container">
            <div style={{ borderBottom: "1px solid #ddd4d4" }}>
                <Nav
                    tabs
                    style={{
                        backgroundColor: "white",
                        width: "50px",
                        display: "grid",
                        gridTemplateColumns: `repeat(${TAB_CONFIG.length}, 1fr)`,
                        border: "unset",
                    }}
                >
                    {TAB_CONFIG.map((tab, index) => (
                        <NavItem
                            key={index}
                            data-testid={`forms-tab-${tab.titleKey.toLowerCase().replace(/\s+/g, "-")}`}
                            className={classNames(
                                "pb-1",
                                "d-flex align-items-center text-nowrap",
                                {
                                    "disable-nav-item__clz":
                                        activeTab !== index,
                                }
                            )}
                            style={{
                                cursor: "pointer",
                                borderBottom:
                                    activeTab === index
                                        ? `${mainColor} 3px solid`
                                        : "",
                            }}
                        >
                            <NavLink
                                className={classNames("text-dark w-100", {
                                    "active customer-account-menu-nav-link-active__clz":
                                        activeTab === index,
                                    "customer-account-menu-nav-link-disable__clz":
                                        activeTab !== index,
                                })}
                                onClick={() => toggleNav(index)}
                            >
                                <span
                                    className="px-2"
                                    style={{
                                        font: "normal normal 600 20px/27px Segoe UI",
                                    }}
                                >
                                    {t(tab.titleKey)}
                                </span>
                            </NavLink>
                        </NavItem>
                    ))}
                </Nav>
            </div>

            <TabContent activeTab={activeTab} className="h-100" data-testid="forms-tab-content">
                {TAB_CONFIG.map((tab, index) => (
                    <TabPane tabId={index} key={index} style={{ height: "90%" }} data-testid={`forms-tab-pane-${index}`}>
                        <div className="banner-container mt-2">
                            {tab.component && React.createElement(tab.component)}
                        </div>
                    </TabPane>
                ))}
            </TabContent>
        </div>
    );
}
